import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type ITableModelDefault } from 'shared/ui/TableNew'

export type IQuietHoursRowOrigin = ITableModelDefault & {
  days: string
  timeRange: string
}

export class RowQuietHours extends RowBase<IQuietHoursRowOrigin> {
  constructor(origin: IQuietHoursRowOrigin) {
    super(origin)
    makeObservableRowBase(this)
  }

  get days() {
    return this.origin.days
  }

  get timeRange() {
    return this.origin.timeRange
  }
}
